import logo from '../../assets/images/brand/footer_logo.png';
import { Reveal } from '../ui/Reveal';

const MANAGER_URL = 'https://t.me/BandaApps_Manager';

export const Footer = ({ t }) => (
  <footer className="footer" id="contacts">
    <div className="footer__image" />
    <div className="footer__inner">
      <Reveal>
        <span className="eyebrow">{t('footer.eyebrow')}</span>
        <h2>{t('footer.title')}</h2>
        <a className="button button--primary" href={MANAGER_URL} target="_blank" rel="noreferrer">
          {t('hero.cta')}
        </a>
      </Reveal>

      <div className="footer__bottom">
        <img src={logo} alt="Banda Apps" />
        <div className="footer__links">
          <a href="https://t.me/banda_appss" target="_blank" rel="noreferrer">{t('footer.channel')} ↗</a>
          <a href="https://t.me/BandaApps_Manager" target="_blank" rel="noreferrer">{t('footer.manager')} ↗</a>
          <a href="https://www.instagram.com/banda.apps/" target="_blank" rel="noreferrer">{t('footer.instagram')} ↗</a>
        </div>
      </div>
    </div>
  </footer>
);
